import React from 'react';
import DownloadApp from '../assets/icons/DownloadApp.svg';
import RouteMapIcon from '../assets/icons/RouteMapIcon.svg';
import TimeIcon from '../assets/icons/TimeIcon.svg';
import RateIcon from '../assets/icons/RateIcon.svg';
import './HowToRideSection.css';

const HowToRideSection = () => {
  const steps = [
    {
      number: '1',
      image: DownloadApp,
      title: 'Download the App',
      description: 'Available on iOS and Android. Sign up in minutes using your phone number and email. Add your payment method securely.'
    },
    {
      number: '2',
      image: RouteMapIcon,
      title: 'Choose Your Ride',
      description: 'Select from Standard Rides, Women-for-Women, or Group Rides. View pricing upfront with no surprises.'
    },
    {
      number: '3',
      image: TimeIcon,
      title: 'Track in Real-Time',
      description: 'Watch your driver approach in real-time. Share your trip details with friends and family for added safety.'
    },
    {
      number: '4',
      image: RateIcon,
      title: 'Ride & Rate',
      description: 'Enjoy your safe ride. Rate your driver and provide feedback to help us maintain the highest standards.'
    }
  ];

  return (
    <section id="ride" className="how-to-ride-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">How to Ride</h2>
          <p className='ride-subtitle'>FOR RIDERS</p>
        </div>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="info-card">
              <div className="info-card__inner">
                <div className="info-card__left">
                  <div className="info-card__icon">
                    <img src={step.image} alt="" aria-hidden="true" />
                  </div>

                  <h3 className="info-card__title">{step.title}</h3>
                  <p className="info-card__text">{step.description}</p>
                </div>

                <div className="info-card__number" aria-hidden="true">
                  {step.number}
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HowToRideSection;